import clsx from 'clsx';
import { FieldError } from '../shadcn/field';

export const LabelError = ({ children, className }: React.PropsWithChildren<{ className?: string }>) => {
  const errorMessage = children as string;

  return (
    <FieldError data-elements={errorMessage} className={clsx('text-body-large text-danger-dark', className)}>
      {children}
    </FieldError>
  );
};
